// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2NuUb","large":"styles_large__7jQ-e"};